module.exports = __webpack_public_path__ + "static/media/tg.d0334199.svg";